export const InvestorDashboardBorrowerStatuses = [
	{ id: 'InComplete', name: 'Incomplete' },
	{ id: 'Pending', name: 'Pending' },
	{ id: 'Approved', name: 'Approved' },
	{ id: 'Archived', name: 'Archived' },
];

export const InvestorDashboardLoanStatuses = [
	{ id: 'PreCredit', name: 'Pre Credit' },
	{ id: 'Credit', name: 'Credit' },
	{ id: 'PreCompliance', name: 'Pre Compliance' },
	{ id: 'Compliance', name: 'Compliance' },
	{ id: 'PreFundraising', name: 'Pre Fundraising' },
	{ id: 'Fundraising', name: 'Fundraising' },
	{ id: 'FullyFilled', name: 'Fully Filled' },
	{ id: 'OnTime', name: 'On Time' },
	{ id: 'Late', name: 'Late' },
	{ id: 'Default', name: 'Default' },
	{ id: 'Rejected', name: 'Rejected' },
	{ id: 'Expired', name: 'Expired/Cancel' },
	{ id: 'FullyPaid', name: 'Fully Paid' },
];
